import { Controller } from "stimulus";
import {openModal} from "../util/modal";

export default class extends Controller {
  static targets = ["amountInput", "detailsButton", "totalPrice", "submitButton", "chartFrame", "cardWrapper"];
  initialize() {
    this.filters = [];
  }

  connect() {
    const total_amount = this.calculateTotalPrice();
    this.totalPriceTarget.innerHTML = `${this.numberWithDelimiter(total_amount)}€`;
  }

  calculateTotalPrice() {
    let total_price = 0;
    this.amountInputTargets.forEach((el) => {
      total_price += el.value * el.dataset.price;
    });
    return total_price;
  }

  onAmountInput() {
    const total_amount = this.calculateTotalPrice();
    this.amountInputTargets.forEach((el) => {
      const targetBtn = el.closest(".silver-product-footer").querySelector(".silver-product-button");
      if (+el.value > 0) {
        targetBtn.classList.add("btn-primary");
        targetBtn.classList.remove("border", "border-secondary");
      } else {
        targetBtn.classList.add("border", "border-secondary");
        targetBtn.classList.remove("btn-primary");
      }
    });
    this.submitButtonTarget.disabled = total_amount === 0;
    this.totalPriceTarget.innerHTML = `${this.numberWithDelimiter(total_amount)}€`;
  }

  onClickOpenProductModal(e) {
    e.preventDefault();
    
    openModal({
      url: e.currentTarget.href,
      modalClass: "modal-xl"
    });
  }

  numberWithDelimiter(x) {
    return x.toFixed(2).toString().replace(".", ",").replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  }

  onPanelClick(e) {
    const target = e.target;
    
    if (this.isButtonClicked(target)) {
      this.deactivateAllButtons(e.currentTarget);
      this.activateClickedButton(target);
      
      if (this.hasChartFrameTarget) {
        const chartFrameUrl = this.getChartFrameUrl(target.dataset.timeframe);
        this.updateChartFrameSource(chartFrameUrl);
      }
    }
  }
  
  isButtonClicked(target) {
    return (
      target.tagName.toLowerCase() === "button" &&
      target.hasAttribute("data-timeframe") &&
      !target.classList.contains("active")
    );
  }
  
  deactivateAllButtons(container) {
    container.querySelector(".active")?.classList.remove("active");
  }
  
  activateClickedButton(button) {
    button.classList.add("active");
  }
  
  getChartFrameUrl(timeframe) {
    const baseChartFrameUrl = window.location.href.includes("/customer_center/silver_calculations/new")
      ? "/customer_center/silver_calculations/silver_chart"
      : "/silver_calculations/silver_chart";
    return `${baseChartFrameUrl}?timeframe=${timeframe}`;
  }
  
  updateChartFrameSource(url) {
    this.chartFrameTarget.src = url;
  }
  
  toggleItems() {
    if (this.filters.length) {
      this.cardWrapperTargets.forEach(el => {
        if (!el.matches(".d-none")){
          el.classList.add("d-none");
        }
      });
      this.cardWrapperTargets.forEach(el => {
        const elFiltersArr = el.dataset.tags.split(",");
        elFiltersArr.forEach(i => {
          if (this.filters.includes(i)) {
            el.classList.remove("d-none");
          }
        });
      });
    } else {
      this.cardWrapperTargets.forEach(el => el.classList.remove("d-none"));
    }
  }

  onFilterItemslClick(e) {
    const target = e.target.closest(".item-label");
    if (target.matches(".selected")) {
      target.classList.remove("selected");
      target.querySelector(".icon").classList.replace("fa-check-square", "fa-square");
      this.filters.splice(this.filters.indexOf(target.dataset.filter), 1);
      this.toggleItems();
    } else {
      target.classList.add("selected");
      target.querySelector(".icon").classList.replace("fa-square", "fa-check-square");
      this.filters.push(target.dataset.filter);
      this.filters.sort();
      this.toggleItems();
    }
  }
}
